    import React from 'react';
    import useNotifications from '../../../api/notifications';
    import { Link } from 'react-router-dom';

    export default function NotificationsList() {
        const { list, markRead, markAll } = useNotifications({ page: 1, limit: 20 });

        if (list.isLoading) return <div className="p-3 text-muted">Loading…</div>;
        if (list.isError) return <div className="p-3 text-danger">{list.error?.message || 'Failed to load'}</div>;

        const items = list.data?.data || [];

        return (
            <div className="card">
                <div className="card-header d-flex align-items-center">
                    <strong>Notifications</strong>
                    <button className="btn btn-outline-secondary btn-sm ms-auto" onClick={() => markAll.mutate()}>
                        Mark all read
                    </button>
                </div>
                <ul className="list-group list-group-flush">
                    {items.length === 0 && <li className="list-group-item text-muted">No notifications</li>}
                    {items.map(n => (
                        <li key={n._id} className="list-group-item d-flex align-items-start">
                            <div className="me-auto">
                                <div className="fw-semibold">{n.title}</div>
                                {n.body && <div className="text-muted small">{n.body}</div>}
                                {n.link && (
                                    <div className="mt-1">
                                        <Link to={n.link} className="small">Open</Link>
                                    </div>
                                )}
                            </div>
                            {!n.readAt && (
                                <button className="btn btn-sm btn-outline-primary" onClick={() => markRead.mutate(n._id)}>
                                    Mark read
                                </button>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
